<template>
  <PostPackagesDatatable
      :post-indexes="postIndexes"
      :post-packages="postPackages"
      :loading="loading"
      :total="total"
      @update="onUpdate"
      :allow-new-button="true"
      :allow-new-group-button="true"
  />
</template>

<script>
import PostPackagesDatatable from '@/components/PostPackagesDatatable'
import PostPackageService from "@/services/post.package.service";
import PostIndexService from "@/services/post.index.service";
import {LAYOUT_LOADING_START, LAYOUT_LOADING_STOP, LAYOUT_TITLE_CHANGED} from "@/store/modules/layout/actions";
import Moment from "moment";
import _ from "underscore";
import Mapper from '@/mappers'
import * as AppEvents from '@/events/app'
import {AllowCreatePostPackage} from "@/enums/permission";

export default {
  name: "PostPackagesView",
  components: {
    PostPackagesDatatable
  },
  data() {
    return {
      postIndexes: [],
      postPackages: [],
      total: 0,
      loading: false
    }
  },
  computed: {
    isAllowPostPackagesListing() {
      return !!_.find(this.$store.getters.appLogin.permissions, p => {
        return p === AllowCreatePostPackage
      })
    },
  },
  methods: {
    onUpdate(options, filters) {
      this.reloadPostPackages(options, filters)
    },
    reloadPostPackages(options, filters) {
      this.loading = true;
      this.$store.dispatch(LAYOUT_LOADING_START)

      const {sortBy, sortDesc, page, itemsPerPage} = options;
      const {region, start, end, postIndex, courier} = filters;

      const skip = (page - 1) * itemsPerPage;

      PostPackageService.getDatatable({
        skip: skip,
        limit: itemsPerPage,
        sort: sortBy.length === 1 ? sortBy[0] : null,
        desc: sortDesc.length === 1 ? sortDesc[0] : null,
        client: this.$store.getters.appActiveClient,
        region: region,
        start: start ? Moment(start, 'YYYY-MM-DD') : null,
        end: end ? Moment(end, 'YYYY-MM-DD') : null,
        postIndex: postIndex,
        courier: courier
      })
          .then(response => {
            this.postPackages = _.map(response.data.Records, postPackageViewModel => {
              return Mapper.mapPostPackage(postPackageViewModel)
            })

            this.total = response.data.Total;
          }, () => {

          })
          .finally(() => {
            this.loading = false;
            this.$store.dispatch(LAYOUT_LOADING_STOP)
          })
    },
    loadPostIndexes() {
      PostIndexService.getAll({})
          .then(response => {
            this.postIndexes = _.map(response.data, Mapper.mapPostIndex)
          })
    },

    onPostPackageGroupCreated(postPackageGroup) {
      this.$router.push({name: 'post-package-group', params: {uid: postPackageGroup.uid}})
    }
  },
  created() {
    this.$bus.$on(AppEvents.APP_POST_PACKAGE_GROUP_CREATED, this.onPostPackageGroupCreated)

    if (this.isAllowPostPackagesListing) {
      this.loadPostIndexes()
      this.$store.dispatch(LAYOUT_TITLE_CHANGED, 'Пост пакеты')
    } else {
      this.$router.go(-1)
    }
  },
  beforeDestroy() {
    this.$bus.$off(AppEvents.APP_POST_PACKAGE_GROUP_CREATED, this.onPostPackageGroupCreated)
  }
}
</script>

<style scoped>

</style>